/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetCountContactsEmailTransactionsResponseData,
  GetCountContactsEmailTransactionsResponseDataFromJSON,
  GetCountContactsEmailTransactionsResponseDataFromJSONTyped,
  GetCountContactsEmailTransactionsResponseDataToJSON
} from './GetCountContactsEmailTransactionsResponseData'

/**
 *
 * @export
 * @interface GetCountContactsEmailTransactionsResponse
 */
export interface GetCountContactsEmailTransactionsResponse {
  /**
   *
   * @type {number}
   * @memberof GetCountContactsEmailTransactionsResponse
   */
  status?: number
  /**
   *
   * @type {GetCountContactsEmailTransactionsResponseData}
   * @memberof GetCountContactsEmailTransactionsResponse
   */
  data?: GetCountContactsEmailTransactionsResponseData
}

export function GetCountContactsEmailTransactionsResponseFromJSON(
  json: any
): GetCountContactsEmailTransactionsResponse {
  return GetCountContactsEmailTransactionsResponseFromJSONTyped(json, false)
}

export function GetCountContactsEmailTransactionsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetCountContactsEmailTransactionsResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetCountContactsEmailTransactionsResponseDataFromJSON(json['data'])
  }
}

export function GetCountContactsEmailTransactionsResponseToJSON(
  value?: GetCountContactsEmailTransactionsResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetCountContactsEmailTransactionsResponseDataToJSON(value.data)
  }
}
